import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import './ViewRecipientsStyle.css'
import '../ModalStyle.css'
import { InputField } from '@components/common'
import { getFullName } from '@utils/fullname.util'
import { ICampaignRecipient } from '@dataTypes/marketing.type'
import { formatPhoneNumber } from '@utils/numberFormatter.util'

type ViewRecipientsProps = {
  recipients: ICampaignRecipient[]
  show: boolean
  onHide: () => void
}

const ViewRecipientsModal: React.FC<ViewRecipientsProps> = ({
  recipients,
  show,
  onHide,
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [filteredRecipients, setFilteredRecipients] = useState(recipients)

  useEffect(() => {
    const search = searchQuery.toLowerCase().trim()

    setFilteredRecipients(
      search.length > 0
        ? recipients.filter((recipient) => {
            return getFullName(recipient.contact, true)
              .toLowerCase()
              .includes(searchQuery.toLowerCase().trim())
          })
        : recipients,
    )
  }, [searchQuery, recipients])

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="view-recipients-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>View recipients</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InputField
          placeholder="Search patient"
          leftIcon={<span className="mgc_search_2_line" />}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <div className="vrm-contact-list">
          {filteredRecipients
            .filter(
              (recipient, index, arr) =>
                arr.findIndex((r) => r.contact_id === recipient.contact_id) ===
                index,
            )
            .map((recipient) => (
              <div key={recipient.contact_id} className="vrm-contact-item">
                <span className="vrm-ci-name">
                  {getFullName(recipient.contact, true)}
                </span>
                <span className="vrm-ci-cellphone">
                  {recipient.contact?.cellphone
                    ? formatPhoneNumber(recipient.contact?.cellphone)
                    : 'N/A'}
                </span>
              </div>
            ))}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ViewRecipientsModal
